module.exports = __webpack_public_path__ + "static/javelin-of-lightning-mtg_clb-0a67e76074b21d302fc15d2f5e20ff44.webp";